<template>
    <im-select :theme="theme" v-model:value="modelVal" v-outsideclick="onHide" @toggle="handleToggle">
        <template #place>
            <template v-if="!inMore">
                <div :class="['oc-box-place', labelClass]">
                    <div class="desc">
                        <div>{{ title }}</div>
                    </div>
                    <div class="icon" :class="{ rotate: show }">
                        <span
                            class="iconfont icon-small-down"
                        ></span>
                    </div>
                </div>
            </template>
        </template>
        <template #default>
            <im-option
                v-for="option in options"
                :key="option.value"
                :value="option.value"
                :label="option.label"
            />
        </template>
    </im-select>
</template>

<script>
import classNames from 'classnames';
export default {
    i18next: {
        ns: 'md-search-bar'
    },
    name: 'OutsideCheckbox',
    emits: ['change'],
    props: {
        data: {
            type: Object,
            default: () => ({})
        },
        label: {
            type: String,
            default: ''
        },
        kee: {
            type: String,
            default: ''
        },
        inMore: {
            type: Boolean,
            default: false
        },
        checked: {
            type: Boolean,
            default: false
        },
        theme: {
            type: String,
            default: 'standard'
        }
    },
    computed: {
        title() {
            const value = this.modelVal[0];
            if (value === 1) {
                return this.$t('md-search-bar.only', { label: this.label });
            } else {
                return this.label;
            }
        },
        options() {
            return [
                { value: 2, label: this.$t('md-search-bar.any') },
                {
                    value: 1,
                    label: this.$t('md-search-bar.only', { label: this.label })
                }
            ];
        },
        modelVal: {
            get() {
                if (this.checked) {
                    return [1];
                } else {
                    return [2];
                }
            },
            set(val) {
                const status = val[0] === 1;
                this.$emit('change', {
                    checked: status,
                    kee: this.kee,
                    inputType: 'checkBox'
                });
                this.show = false;
            }
        },
        labelClass({ theme, checked, show }) {
            let temp = []
            if (checked || show) {
                temp.push('active')
            }
            return classNames(theme, temp);
        }
    },
    data: function() {
        return {
            show: false
        }
    },
    methods: {
        onHide() {
            this.show = false
        },
        handleToggle(show) {
            this.show = show;
        }
    }
};
</script>

<style lang="scss">
.oc-box-place {
    display: flex;
    align-items: center;
    justify-content: center;
    .desc {
        flex: 1 0 0;
        overflow: hidden;
        div {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    &.standard {
        .desc {
            font-size: 16px;
            color: #515666;
            text-align: right;
            margin-right: 5px;
        }
    }
    &.template4 {
        .desc {
            text-align: right;
            font-size: 16px;
            font-family: var(--font-medium);
            color: #8b93a7;
            margin-right: 10px;
        }
        .icon {
            .iconfont {
                margin-left: 0 !important;
                margin-right: 0;
                color: #8b93a7;
                font-size: 18px;
                font-weight: bold;
            }
        }
    }
    &.broker {
        .desc {
            font-size: 16px;
            color: #191919;
            text-align: right;
            margin-right: 5px;
        }
        .icon {
            .iconfont {
                margin-right: 0;
                font-size: 14px;
                color: #000;
            }
        }
    }
    .icon {
        transform-origin: 50% 50%;
        transition: transform 0.5s ease-in-out;
        &.rotate {
            transform: rotate(180deg);
        }
    }
}
</style>
